import {
  PaginationState,
} from '@tanstack/react-table';
import {
  UserMessageDTO,
} from 'dtos';
import {
  postApiUserMessageRequestUserMessageList,
} from 'endpoints';

type InboxMessagesDataParams = {
  unseenOnly?: boolean;
  pagination?: PaginationState;
  setTotalSize?: (size: number) => void;
};

export default async function getInboxMessagesData({
  unseenOnly = false,
  pagination,
  setTotalSize,
}: InboxMessagesDataParams): Promise<UserMessageDTO[]> {
  const request = {
    unseenOnly,
    pageRequest: {
      pageIndex: pagination?.pageIndex ?? 0,
      pageSize: pagination?.pageSize ?? 25,
    },
  };
  const response = await postApiUserMessageRequestUserMessageList(request);

  setTotalSize?.(response.messages?.pageProperties?.totalSize ?? 0);

  return (response.messages?.data ?? []);
}
